import { useEffect, useRef } from "react";
import type { MessageSchema } from "../hooks/useGuidedChat";
import { MessageBubble } from "./MessageBubble";
import { StreamingMessage } from "./StreamingMessage";

interface MessageListProps {
  messages: MessageSchema[];
  streamingContent?: string;
  isStreaming?: boolean;
  initialQuestion?: string;
}

export function MessageList({
  messages,
  streamingContent,
  isStreaming,
  initialQuestion,
}: MessageListProps) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, streamingContent]);

  // Filter out the first assistant message if we're showing initial question separately
  const displayMessages = initialQuestion
    ? messages.filter(
        (msg, idx) => !(idx === 0 && msg.role === "assistant")
      )
    : messages;

  return (
    <div className="flex-1 overflow-y-auto px-6 py-6 space-y-6">
      {/* Initial question displayed prominently at top in serif font */}
      {initialQuestion && (
        <div className="mb-6 text-text-primary">
          <p className="font-serif text-2xl leading-snug">{initialQuestion}</p>
        </div>
      )}

      {/* Rest of the conversation */}
      {displayMessages.map((message, index) => (
        <MessageBubble key={index} message={message} />
      ))}

      {/* Streaming response */}
      {isStreaming && (
        <StreamingMessage content={streamingContent || ""} />
      )}

      <div ref={bottomRef} />
    </div>
  );
}
